<template>
  <div>
    <el-form class="selectlesson">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getTvideo"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item clearable label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            clearable
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getTvideo"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template v-show="tableData">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="日期"
          :formatter="formatDate"
          width="150"
        >
        </el-table-column>
        <el-table-column prop="tvName" label="试听名称"> </el-table-column>

        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="tvideoView(scope.row)"
              icon="el-icon-view"
              type="primary"
              size="small"
              plain
              >查看试听</el-button
            >
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="delTvideo(scope.row)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
            <el-button
              style="margin: 3px 3px 3px 3px"
              tag="router-link"
              target="_blank"
              @click="editTvideo(scope.row._id)"
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- <el-skeleton :loading="loading" :rows="10" animated /> -->
    <!--  grade分类分页 -->
    <div class="grade-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="tvideopre"
        @next-click="tvideonext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="tvideoLength"
      >
      </el-pagination>
    </div>
    <!--   目录查看弹窗 -->
    <el-dialog
      :title="viewtvideo.tvName"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="75%"
    >
      <div>
        <el-table :data="viewtvideo.tvideos" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column prop="tvideoId" label="试听ID"> </el-table-column>
          <el-table-column prop="tvideoName" label="试听名"> </el-table-column>
          <el-table-column prop="tvideoVid" label="试听链接"> </el-table-column>
          <el-table-column prop="tvideoTime" label="试听时长">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { timerfilter } from "../util/timerfilter";
//import moment from 'moment'

export default {
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      tableData: [],
      model: [],

      tvideoLength: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      viewtvideo: "",
    };
  },
  methods: {
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getcontent(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        this.getTvideo(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        this.getTvideo(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getTvideo() {
      try {
        const result = await this.$http.get("/tvideo/gettvideo", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });

        this.tableData = result.data[0].result;
        this.tvideoLength = result.data[0].resultLength[0].totalCount;
      } catch (error) {
        console.log(error);
      }
    },
    async tvideoView(row) {
      this.dialogVisible = true;
      const result = await this.$http.get(
        "/tvideo/viewtvideo?_id=" + `${row._id}`
      );
      this.viewtvideo = result.data;
    },
    async delTvideo(row) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          return this.$http.delete("/tvideo/deltvideo?_id=" + `${row._id}`);
        })
        .then((result) => {
          if (result.status === 203) {
            this.$message({
              type: "success",
              message: result.data.msg,
            });
          }

          this.getTvideo();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /* 编辑课程 */
    async editTvideo(id) {
      window.open(`/tvideo/edit/${id}`, "_blank");
    },

    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    //lesson分类分页
    async tvideopre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async tvideonext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTvideo(this.currentPage);
      //console.log(this.currentPage);
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getTvideo();
  },
};
</script>
